module.exports = __webpack_public_path__ + "img/products.07c1cc71.png";